/*
 * Zentrale Feature-/Access-Control-Konfiguration für betty.
 *
 * Verbindliches Prinzip:
 * - Jede neue Funktion erhält eine eindeutige Feature-ID.
 * - minimumAccess entscheidet über free / silver / gold / admin.
 * - active kann ein Feature unabhängig vom Plan komplett abschalten.
 * - Komponenten fragen nur diese zentrale Logik ab.
 *
 * WICHTIG:
 * Dies ist die Frontend-Abbildung für Sichtbarkeit/Bedienbarkeit.
 * Geschützte Backend-Aktionen müssen zusätzlich im Backend abgesichert werden.
 */

export const ACCESS_LEVELS = {
  free: 0,
  silver: 1,
  gold: 2,
  admin: 3,
};

export const FEATURES = {
  MATCH_ANALYSIS_COCKPIT: {
    id: "match-analysis-cockpit",
    minimumAccess: "admin",
    active: true,
    visibleWhenLocked: true,
    label: "Cockpit",
  },
  LEAGUE_POST_MATCH_COMPARISON: {
    id: "league-post-match-comparison",
    minimumAccess: "free",
    active: true,
    visibleWhenLocked: false,
    label: "Post-Match-Spieltag",
  },
};

const normalizeAccessLevel = (value) => {
  const normalized = String(value ?? "")
    .trim()
    .toLowerCase();

  return Object.prototype.hasOwnProperty.call(
    ACCESS_LEVELS,
    normalized,
  )
    ? normalized
    : "free";
};

export const getUserAccessLevel = (user) => {
  const userId =
    user?.user_id ??
    user?.email ??
    user?.id ??
    "";

  /*
   * Admin-Erkennung lebt zentral hier und nicht mehr
   * verteilt in einzelnen React-Komponenten.
   */
  if (
    String(userId).trim().toLowerCase() ===
    "paule@paule-wetten.de"
  ) {
    return "admin";
  }

  return normalizeAccessLevel(
    user?.plan ??
      user?.current_plan ??
      user?.plan_type ??
      "free",
  );
};

export const getFeatureAccess = (feature, user) => {
  if (!feature) {
    return {
      active: false,
      allowed: false,
      visible: false,
      userAccess: getUserAccessLevel(user),
      minimumAccess: null,
    };
  }

  const userAccess = getUserAccessLevel(user);
  const minimumAccess = normalizeAccessLevel(
    feature.minimumAccess,
  );

  const active = feature.active !== false;

  const allowed =
    active &&
    ACCESS_LEVELS[userAccess] >=
      ACCESS_LEVELS[minimumAccess];

  const visible =
    active &&
    (allowed || feature.visibleWhenLocked !== false);

  return {
    active,
    allowed,
    visible,
    userAccess,
    minimumAccess,
  };
};

export const hasFeatureAccess = (feature, user) =>
  getFeatureAccess(feature, user).allowed;
